<template>
  <div>
    <div class="page1"
         v-if="page == 1">
      <div class="gl_title_bar marginBottom10">
        <div class="gl_tb_left">
          <span class="normaltitle">专家入驻申请</span>
        </div>
      </div>
      <div class="xuzhi">
        <div class="xztitle">专家店铺入驻须知</div>
        <div class="xznr">全科知家自2021年上线以来，一直致力于发掘自媒体时代对基层医生最有帮助的优质学术内容，让每一个有水平、有特长的医者成为讲者，让每一个爱学习的医者能够便捷高效的学习。
          请您点击 “专家小铺入驻申请“，提交验证资料，并签署专家入驻协议。欢迎您的入驻，让我们一起为推动全科医学学科建设、基层卫生事业发展而努力。</div>
        <div class="xzbtn"
             @click="page = 2">入驻申请</div>
      </div>
      <div class="list">
        <div class="listtop">
          <img :src="avatarUrl"
               alt="" />
          <span>{{ mobile.substr(0, 8) }}***的专家店铺</span>
        </div>
        <div class="listbox">
          <table>
            <thead>
              <tr>
                <th>专家名称</th>
                <th>审核状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in storeList"
                  :key="index">
                <td>{{ item.expertName }}</td>
                <td>
                  <span v-show="item.autitState == 1">待审核</span>
                  <span v-show="item.autitState == 2"
                        style="color:#FF0000">审核未通过<span v-show="item.audittext">（{{ item.audittext }}）</span></span>
                  <span style="color:#0B8586"
                        v-show="item.autitState == 9">审核已通过</span>
                </td>
                <td>
                  <span style="color:#0B8586;cursor:pointer"
                        @click="toupdata(item.id)"
                        v-show="item.autitState == 1 || item.autitState == 2">修改</span>
                  <span style="color:#0B8586;cursor:pointer"
                        @click="toStore(item.expertId, item.orgName)"
                        v-show="item.autitState == 9">我的店铺</span>
                </td>
              </tr>
              <tr v-show="storeList.length < 1">
                <td colspan="3">暂无店铺信息</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="page2"
         v-if="page == 2">
      <div class="gl_title_bar marginBottom10">
        <div class="gl_tb_left">
          <span class="normaltitle">申请入驻</span>
        </div>
      </div>
      <div class="form">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="93px"
                 style="position:relative;"
                 class="demo-ruleForm">
          <div class="formRow">
            <el-form-item label="姓名："
                          prop="name">
              <el-input v-model="ruleForm.name"
                        placeholder="请输入专家姓名"
                        style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="电话："
                          prop="tel">
              <el-input v-model="ruleForm.tel"
                        placeholder="请输入专家电话（非必填）"
                        style="width: 300px;"></el-input>
            </el-form-item>
          </div>
          <div class="formRow">
            <el-form-item label="学历："
                          prop="edu">
              <el-select v-model="ruleForm.edu"
                         style="width: 300px;"
                         placeholder="请选择学历">
                <el-option v-for="item in eduOptions"
                           :key="item.id"
                           :label="item.valueText"
                           :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="职称/职务："
                          label-width="100px"
                          prop="position">
              <el-select v-model="ruleForm.position"
                         style="width: 300px;"
                         placeholder="请选择职称">
                <el-option v-for="item in positionOptions"
                           :key="item.id"
                           :label="item.valueText"
                           :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="formRow">
            <el-form-item label="科室："
                          prop="department">
              <el-select v-model="ruleForm.department"
                         style="width: 300px;"
                         placeholder="请选择科室">
                <el-option v-for="item in departmentOptions"
                           :key="item.id"
                           :label="item.valueText"
                           :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单位："
                          prop="unit">
              <el-input v-model="ruleForm.unit"
                        placeholder="请输入工作单位"
                        style="width: 300px;"></el-input>
            </el-form-item>
          </div>
          <!--标签-->
          <div v-for="(item, index) in labelOneOptions"
               :key="item.id">
            <el-form-item :label="item.name+'：'"
                          prop="labelOne">
              <el-select v-model="optionsvalues[index].value"
                         style="width: 706px;"
                         multiple
                         placeholder="请选择（可多选）">
                <el-option v-for="optiontime in labelOneOptions[index].queryCoursesInfoList"
                           :key="optiontime.id"
                           :label="optiontime.name"
                           :value="optiontime.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="专长："
                        prop="specialty">
            <el-input type="textarea"
                      class="textarea"
                      placeholder="请输入个人专长，例：擅长糖尿病的诊疗。"
                      style="width: 706px;"
                      v-model="ruleForm.specialty"></el-input>
          </el-form-item>
          <el-form-item label="简介："
                        prop="abstract">
            <el-input type="textarea"
                      class="textarea2"
                      style="width: 706px;"
                      placeholder="请输入个人简介"
                      v-model="ruleForm.abstract"></el-input>
          </el-form-item>
          <el-form-item label="资格证书："
                        label-width="93px"
                        style="position: relative;"
                        prop="certificate">
            <webupload fileaccept=".jpg,.jpeg,.png"
                       :Maxfileszie="3"
                       :uploadtype="1"
                       :orgid="0"
                       :onSuccess="certificateHandleSuccess"
                       :before-upload="beforeAvatarUpload"
                       style="width:105px;height:61px;border: 1px solid #E2E2E2;padding-bottom:-60px;float: left;">
              <img v-if="ruleForm.certificate"
                   :src="ruleForm.certificate"
                   style="width:105px;height:61px"
                   class="avatar" />
              <div v-else
                   style="position: relative;">
                <img src="../../../assets/img/zhengshu.png"
                     style="width:105px;height:61px" />
                <img style=" position: absolute;top: 19px;left: 41px;"
                     src="../../../assets/img/icon/jia3.png" />
              </div>
            </webupload>
            <span style=" position: absolute;bottom: -35px;left:-5px;font-size:12px;">上传医师资格证书1-2</span>
            <webupload fileaccept=".jpg,.jpeg,.png"
                       :Maxfileszie="3"
                       :uploadtype="1"
                       :orgid="0"
                       :onSuccess="certificateHandleSuccess2"
                       :before-upload="beforeAvatarUpload"
                       style="width:105px;height:61px;border: 1px solid #E2E2E2;padding-bottom:-60px;float: left;margin-left:61px">
              <img v-if="ruleForm.certificate2"
                   :src="ruleForm.certificate2"
                   style="width:105px;height:61px"
                   class="avatar" />
              <div v-else
                   style="position: relative;">
                <img src="../../../assets/img/zhengshu.png"
                     style="width:105px;height:61px" />
                <img style=" position: absolute;top: 19px;left: 41px;"
                     src="../../../assets/img/icon/jia3.png" />
              </div>
            </webupload>
            <span style=" position: absolute;bottom: -35px;left:163px;font-size:12px;">上传医师资格证书3-4</span>
          </el-form-item>
          <el-form-item label="只支持jpg格式"
                        label-width="114px"
                        style="position:absolute;top:110px;right:0px;"
                        prop="logoImg">
            <webupload fileaccept=".jpg,.jpeg,.png"
                       :Maxfileszie="3"
                       :uploadtype="1"
                       :orgid="0"
                       :onSuccess="logoHandleSuccess"
                       :before-upload="beforeAvatarUpload"
                       style="width:92px;height:92px;border-radius: 50%;background: #0b868613;position:absolute;top:-110px;left:-105px;">
              <img v-if="ruleForm.logoImg"
                   :src="ruleForm.logoImg"
                   style="width:92px;height:92px"
                   class="avatar" />
              <i v-else
                 style="padding:26px;color:#0B8586;font-size:40px"
                 class="el-icon-plus avatar-uploader-icon"></i>
            </webupload>
            <span style="position:absolute;top:-21px;left:-87px;width:100px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">专家头像</span>
          </el-form-item>
          <el-form-item class="xieyi">
            <el-checkbox v-model="isXieyi"
                         class="xy1"></el-checkbox>
            <span class="xy2">我已阅读和同意</span>
            <span class="xy3"
                  @click="isXieyiBox=true">《全科知家专家入驻协议书》</span>
            <el-dialog title="全科知家专家入驻协议书"
                       :visible.sync="isXieyiBox"
                       class="xieyibox"
                       width="760px">
              <div class="xynr">
                一、特别提示
                您只有无条件同意《全科知家内容上传协议》，才能在全科知家网的文章分区投稿。
                1.1 全科知家同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务(以下称"网络服务")，为获得网络服务，服务使用人(以下称"用户")同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击"同意"按钮即表示用户完全接受本声明项下的全部条款。这些条款可由全科知家域名所有者随时更新，本服务协议一旦发生变动，全科知家将会在相关的页面上提示修改内容。修改后的服务协议一旦在页面上公布即有效代替原来的服务协议。用户可随时造访查阅最新服务协议。用户在使用全科知家提供的各项服务之前，应仔细阅读本服务协议，如用户不同意本服务协议及/或随时对其的修改，用户可以主动取消全科知家提供的服务。
                1.2 全科知家作为信息分享、交流的服务平台，为用户提供原创信息的信息存储空间服务，用户应合法、有权的使用全科知家发表信息并单独对此承担法律责任。
                1.3 用户承诺不得以任何方式使用全科知家直接或间接从事违反中华人民共和国相关法律规定及社会公序良俗的行为，用户不得使用全科知家服务制作、复制、上载、发布、展示或以其它方式传播含有下列内容之一的信息：
                （1）反对宪法所确定的基本原则的；
                （2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                （3）损害国家荣誉和利益的；
                （4）煽动民族仇恨、民族歧视，破坏民族团结的；
                （5）破坏国家宗教政策，宣扬邪教和封建迷信的；
                （6）散布谣言，扰乱社会秩序，破坏社会稳定的；
                （7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
                （8）侮辱或者诽谤他人，侵害他人合法权益的；
                （10）含有法律、行政法规禁止的其他内容的信息。
                二、版权声明
                2.1全科知家作为信息分享、交流的服务平台，尊重和鼓励用户原创内容，打造基于创作的文化原创社区。同时，全科知家也尊重任何第三方的合法权益。用户在使用全科知家发表信息时，不得以任何方式侵害任何第三方的合法权益，包括但不限于著作权、商标权、专利权、姓名权、隐私权等。
                2.2 用户使用全科知家发表的全部原创内容（包括但不限于文章、图片、视频等），其知识产权归用户所有。
                2.3 全科知家不会对用户上传的作品内容作任何形式的编辑修改。
                2.4用户使用全科知家发表的信息，除非用户明确允许转载的，禁止任何第三方转载或者摘编（用户使用官方“生成图片”功能分享的除外）；若该用户允许第三方转载或摘编信息至全科知家之外的平台，应在转载内容的显著位置注明原作者姓名（或笔名、全科知家用户昵称），注明内容来源于全科知家且附有原始链接，并不对转载内容进行修改或演绎。
                2.5对于用户使用全科知家发表的信息，若有相关权利人提出关于侵害著作权等合法权益的投诉，全科知家有权根据法律规定的要求删除相关信息。
              </div>
              <div class="xybtn"
                   @click="toxybtn"
                   :style="xieyiTime==0?'background-color: #0b8586;':''">
                <span>确认</span>
                <span v-show="xieyiTime!=0">（{{xieyiTime}}s）</span>
              </div>
            </el-dialog>
          </el-form-item>
          <el-form-item>
            <div class="xzbtn"
                 style="margin-left:180px"
                 @click="submitForm">提交申请</div>
            <div class="xzbtn"
                 style="margin-left:10px;background: #9EA2A2;"
                 @click="page = 1">取消</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import webupload from '../../../components/webupload/webupload.vue';
export default {
  name: 'userVip',
  components: {
    webupload
  },
  data () {
    return {
      AuthorId: '',
      mobile: '',
      avatarUrl: '',
      page: 1,
      storeList: [],
      ruleForm: {
        name: '',
        tel: '',
        edu: '',
        department: '',
        position: '',
        specialty: '',
        abstract: '',
        unit: '',
        logoImg: '',
        certificate: '',
        certificate2: '',
        certificateId: '',
        certificate2Id: '',
        logoImgId: '',
        labelOnestr: '',
        labelOne: []
      },
      departmentOptions: [],
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        // tel: [
        //   { required: true, message: '请输入电话', trigger: 'blur' }
        // ],
        labelOne: [{ required: true, trigger: 'blur' }],
        edu: [{ required: true, message: '请选择学历', trigger: 'change' }],
        position: [{ required: true, message: '请选择职称/职务', trigger: 'change' }],
        department: [{ required: true, message: '请选择科室', trigger: 'change' }],
        specialty: [{ required: true, message: '请输入专长', trigger: 'blur' }],
        abstract: [{ required: true, message: '请输入个人简介', trigger: 'blur' }],
        unit: [{ required: true, message: '请输入工作单位', trigger: 'blur' }],
        logoImg: [{ required: true, message: '' }],
        certificate: [{ required: true, message: '' }]
      },
      props: {
        multiple: true,
        value: 'id',
        label: 'name',
        children: 'queryCoursesInfoList'
      },
      labelOneOptions: [],
      optionsvalues: [
        { value: [] },
        { value: [] },
        { value: [] },
        { value: [] }
      ],
      isXieyi: false,
      isXieyiBox: false,
      xieyiTime: 3
    };
  },
  created () {
    this.getOptions();
    this.getlabelOneOptions();
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
      this.mobile = JSON.parse(localStorage.getItem('ResData')).mobile;
      this.avatarUrl = JSON.parse(localStorage.getItem('ResData')).avatarUrl;
    }
    this.GetMyStoreList();
  },
  watch: {
    isXieyiBox: function (e) {
      if (e == true && this.xieyiTime != 0) {
        var test1 = setInterval(() => {
          if (this.xieyiTime > 0) {
            this.xieyiTime = this.xieyiTime - 1
          } else {
            clearInterval(test1);
          }
        }, 1000);
      }
    },
    isXieyi: function (e) {
      if (e == true && this.xieyiTime != 0) {
        this.isXieyi = false
        this.isXieyiBox = true
      }
    }
  },
  methods: {
    getOptions () {
      let arr = [1, 6, 3]
      for (let i = 0; i < arr.length; i++) {
        this.httphelper
          .get('/api/BasicsmesApi/GetCodeResultList', {
            type: arr[i]
          })
          .then(res => {
            if (res.code == 200) {
              if (arr[i] == 1) this.eduOptions = res.data;
              else if (arr[i] == 6) this.positionOptions = res.data;
              else if (arr[i] == 3) this.departmentOptions = res.data;
            }
          });
      }

    },
    checkTel (value) {
      const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
      if (reg.test(value)) return false;
      else return true;
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    getlabelOneOptions () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertLabelList').then(res => {
        if (res.code == 200) {
          this.labelOneOptions = res.data.elablist;
        }
      });
    },
    certificateHandleSuccess (response) {
      this.ruleForm.certificate = response.ossfileurl;
      this.ruleForm.certificateId = response.resid;
    },
    certificateHandleSuccess2 (response) {
      this.ruleForm.certificate2 = response.ossfileurl;
      this.ruleForm.certificate2Id = response.resid;
    },
    logoHandleSuccess (response) {
      this.ruleForm.logoImg = response.ossfileurl;
      this.ruleForm.logoImgId = response.resid;
    },
    GetMyStoreList () {
      this.httphelper
        .get('/api/CGPExpertApi/GetExpertStoreRecord', {
          userId: Number(this.AuthorId)
        })
        .then(res => {
          if (res.data) {
            this.storeList = res.data;
          }
        });
    },
    submitForm () {
      if (this.isXieyi == false) {
        return this.isXieyiBox = true
      }
      var valuess = '';
      for (let i = 0; i < this.labelOneOptions.length; i++) {
        if (valuess == '') valuess = this.optionsvalues[i].value.toString()
        else valuess += ',' + this.optionsvalues[i].value;
      }
      if (this.ruleForm.name == '') return this.$message.warning('姓名不能为空');
      else if (valuess == '') return this.$message.warning('请选择标签');
      else if (this.ruleForm.edu == '') return this.$message.warning('请选择学历');
      else if (this.ruleForm.position == '') return this.$message.warning('请选择职称');
      else if (this.ruleForm.department == '') return this.$message.warning('请选择科室');
      else if (this.ruleForm.specialty == '') return this.$message.warning('专长不能为空');
      else if (this.ruleForm.abstract == '') return this.$message.warning('简介不能为空');
      else if (this.ruleForm.unit == '') return this.$message.warning('工作单位不能为空');
      else if (this.ruleForm.certificate == '' || this.ruleForm.certificate2 == '') return this.$message.warning('请上传资格证书');
      else if (this.ruleForm.logoImg == '') return this.$message.warning('请上传专家头像');
      this.httphelper
        .post('/api/CGPExpertApi/ExpertEnter', {
          userId: Number(this.AuthorId),
          id: 0,
          Name: this.ruleForm.name,
          Mobile: this.ruleForm.tel.toString(),
          Subjectval: Number(this.ruleForm.department),
          TechTitleval: Number(this.ruleForm.position),
          Educationval: Number(this.ruleForm.edu),
          Unit: this.ruleForm.unit,
          Speciality: this.ruleForm.specialty,
          DetailsInfo: this.ruleForm.abstract,
          Pictureonerid: Number(this.ruleForm.certificateId),
          Picturetworid: Number(this.ruleForm.certificate2Id),
          HeadPictureRid: Number(this.ruleForm.logoImgId),
          labelOne: valuess
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('申请入驻成功');
            this.GetMyStoreList();
            this.page = 1;
          } else if (res.data.code == 206) {
            this.$message.error('当前专家已入驻，请勿重复入驻');
          } else {
            this.$message.error('入驻失败');
          }
        });
    },
    toupdata (id) {
      this.$router.push({
        path: '/user/expertsEnterUpdate',
        query: {
          id: id
        }
      });
    },
    toStore (id, name) {
      localStorage.setItem('storeId', id);
      localStorage.setItem('storeType', 1);
      localStorage.setItem('storeName', name);
      this.$router.push({
        name: 'uaInfor'
      });
    },
    tolabelOne (e) {
      this.ruleForm.labelOnestr = '';
      for (let i = 0; i < e.length; i++) {
        if (this.ruleForm.labelOnestr == '') {
          this.ruleForm.labelOnestr = e[i].toString();
        } else {
          this.ruleForm.labelOnestr = this.ruleForm.labelOnestr + ',' + e[i];
        }
      }
    },
    toxybtn () {
      if (this.xieyiTime == 0) {
        this.isXieyiBox = false
        this.isXieyi = true
      }
    }
  }
};
</script>

<style scoped>
.xuzhi {
    border-bottom: 1px solid #e2e2e2;
    padding-bottom: 36px;
}
.xuzhi .xztitle {
    height: 18px;
    line-height: 18px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    border-left: 2px solid #0b8586;
    padding-left: 14px;
    margin-top: 38px;
    margin-bottom: 10px;
}
.xuzhi .xznr {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 34px;
    height: 160px;
    overflow-y: auto;
    padding-right: 50px;
    text-indent: 28px;
}
.xzbtn {
    margin-top: 12px;
    margin-left: 375px;
    width: 200px;
    height: 36px;
    background: #0b8586;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
}
.listtop {
    height: 80px;
    margin-top: 20px;
    display: flex;
    align-items: center;
}
.listtop img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    border-radius: 50%;
}
.listtop span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    width: 33.3%;
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    width: 33.3%;
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.form {
    padding-top: 30px;
}
.formRow {
    width: 799px;
    display: flex;
    justify-content: space-between;
}
.textarea ::v-deep .el-textarea__inner {
    height: 82px;
    font-family: Microsoft YaHei !important;
}
.textarea2 ::v-deep .el-textarea__inner {
    height: 98px;
    font-family: Microsoft YaHei !important;
}
.xieyi {
    font-size: 14px;
    color: #606266;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 0;
}
.xieyi ::v-deep .el-form-item__content {
    margin-top: 30px;
}
.xieyi .xy1 {
    margin-right: 8px;
}
.xieyi .xy1 ::v-deep .el-checkbox__inner {
    border-color: #0b8586;
}
.xieyi .xy1 ::v-deep.is-checked .el-checkbox__inner {
    background-color: #0b8586;
}
.xieyi .xy3 {
    color: #0b8586;
    cursor: pointer;
}
.xieyibox ::v-deep .el-dialog {
    height: 550px;
}
.xieyibox ::v-deep .el-dialog__header {
    text-align: center;
    padding-bottom: 0px;
    font-weight: 800;
}
.xieyibox .xynr {
    height: 355px;
    padding: 0 10px;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.xieyibox .xynr::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.xieyibox .xynr::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background: #0b86864d;
    opacity: 0.3;
    border-radius: 6px;
}
.xieyibox .xynr::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: #fff;
    border-radius: 6px;
}
.xieyibox .xybtn {
    width: 160px;
    height: 40px;
    /* background-color: #0b8586; */
    background-color: #0b868638;
    border-radius: 20px;
    margin: 30px auto 0;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
}
</style>
